import React from 'react'

import { Download, Upload } from "../../../../components/icons/Icons"

const Header = () => {

    const handleFileDownloadUpload = (type) => {
        console.log(type)
    }

    const headers = [
        { id: 1, semiLabel: "12BB", label: "Form 12BB", icon: <Download />, type: "download", onclick: handleFileDownloadUpload },
        { id: 2, semiLabel: "12BB", label: "Upload 12BB", icon: <Upload />, type: "upload", onclick: handleFileDownloadUpload },
        { id: 3, semiLabel: "16-A", label: "Form 16-A", icon: <Upload />, type: "upload", onclick: handleFileDownloadUpload },
        { id: 4, semiLabel: "16-B", label: "Form 16-B", icon: <Upload />, type: "upload", onclick: handleFileDownloadUpload },
        { id: 5, semiLabel: "16", label: "Download From 16", icon: <Download />, type: "download", onclick: handleFileDownloadUpload },
    ]

    return (
        <div>
            <div className='emp-tds-top-header'>
                {
                    headers.map(item => {
                        return <button onClick={() => item.onclick(item.type)} key={item.id}> {item.icon} {item.label} </button>
                    })
                }
            </div>
        </div>
    )
}

export default Header